import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import 'components/portal/administration/administration.css';
import './Reporting.css';

import { TodayOutlined, EventOutlined } from '@mui/icons-material';


interface IDateRangePickerProps {
    className?: string;
    fromDate?: Date;
    toDate?: Date;
    setter: (fromDate?: Date | null, toDate?: Date | null) => void;
}

const DateRangePicker = (props: IDateRangePickerProps) => {
    return (
        <div className={props.className}>

            <label className="mr-5">
                <span className="pr-2">From:</span>
                <DatePicker
                    className="ml-2 mr-2"
                    dateFormat="dd/MM/yyyy"
                    selected={props.fromDate}
                    maxDate={props.toDate}
                    onChange={(d: Date | null) => props.setter(d, props.toDate)}
                />
                <TodayOutlined />
            </label>

            <label>
                <span className="pr-2">To:</span>
                <DatePicker
                    className="ml-2 mr-2"
                    dateFormat="dd/MM/yyyy"
                    selected={props.toDate}
                    minDate={props.fromDate}
                    onChange={(d: Date | null) => props.setter(props.fromDate, d)}
                />
                <EventOutlined />
            </label>

        </div>
    );
};

export default DateRangePicker;
